import React, { useState } from 'react'
import { Modal, Button, Checkbox } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

const MMA_POPUP_STORAGE_KEY = 'hideMmaPopup'

const MmaPopup = ({
  isOpen,
  onClose,
  onYes,
  onNo
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false)
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      centered
      width="min(500px, 90vw)"
      onCancel={onClose}
      styles={{
        body: {
          padding: 'clamp(16px, 4vw, 40px)'
        }
      }}
    >
      <div
        style={{
          position: 'relative',
          textAlign: 'center'
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '-20px',
            right: '-40px',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontSize: '24px',
            zIndex: 10,
            color: '#555'
          }}
        >
          <CloseOutlined />
        </button>

        {/* Title */}
        <h1
          style={{
            fontSize: 'clamp(22px, 5vw, 30px)',
            fontWeight: 700,
            marginBottom: '16px',
            paddingTop: '8px'
          }}
        >
          Do you have a MMA account?
        </h1>

        <img
          src="/images/mma-logo.svg"
          alt="mma"
          style={{
            width: 'min(220px, 70vw)',
            objectFit: 'contain'
          }}
        />

        {/* Description */}
        <p
          style={{
            fontSize: 'clamp(16px, 3vw, 24px)',
            marginBottom: '20px'
          }}
        >
          Please select an option to continue
        </p>

        {/* Buttons */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            flexWrap: 'wrap'
          }}
        >
          <Button
            type="primary"
            onClick={onYes}
            style={{
              background: 'transparent',
              color: '#703895',
              border: '2px solid #703895',
              flex: '1 1 180px',
              maxWidth: '200px',
              minWidth: '140px'
            }}
          >
            YES
          </Button>

          <Button
            type="primary"
            onClick={onNo}
            style={{
              background: 'transparent',
              color: '#703895',
              border: '2px solid #703895',
              flex: '1 1 180px',
              maxWidth: '200px',
              minWidth: '140px'
            }}
          >
            NO
          </Button>
        </div>

        {/* Don't show again */}
        <div
          style={{
            marginBottom: '32px',
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Checkbox
            checked={dontShowAgain}
            onChange={(e) => {
              const checked = e.target.checked
              setDontShowAgain(checked)
              if (checked) {
                localStorage.setItem(MMA_POPUP_STORAGE_KEY, 'true')
              } else {
                localStorage.removeItem(MMA_POPUP_STORAGE_KEY)
              }
            }}
          >
            <span
              style={{
                fontSize: 'clamp(14px, 2.5vw, 16px)',
                color: '#777'
              }}
            >
              Don't show this again
            </span>
          </Checkbox>
        </div>

        {/* Note */}
        <p
          style={{
            fontSize: 'clamp(12px, 2vw, 14px)',
            color: '#1696d2',
            fontStyle: 'italic',
            lineHeight: '1.6',
            margin: 0
          }}
        >
          Note: This is a one-time login process. All doctors are required to
          sign in with their MMA account to be eligible for MMA CPD point
          accreditation for the IMFeD Paediatric Growth & Nutrition Online
          Course.
        </p>
      </div>
    </Modal>
  )
}

export default MmaPopup